import React from 'react';

import { MatchingProducts } from '@/app/_components/MatchingProducts';
import { MatchingProductsProps } from './types';

import classes from './index.module.scss';

export const MatchingProductsGraphQL: React.FC<MatchingProductsProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <MatchingProducts matchingProducts={props} />
    </div>
  );
};

export default MatchingProductsGraphQL;
